import { Link } from 'react-router-dom';

export default function Logo({ className = '', light = false }: { className?: string; light?: boolean }) {
  return (
    <Link
      to="/"
      aria-label="The Clothing Plug — home"
      className={`group inline-flex items-center gap-2.5 no-underline ${className}`}
    >
      <span
        aria-hidden
        className="grid h-10 w-10 place-items-center rounded-xl transition-all duration-300 group-hover:shadow-glow"
        style={{ background: light ? 'rgba(255,255,255,0.1)' : 'rgb(var(--sand))', border: `1px solid ${light ? 'rgba(255,255,255,0.15)' : 'rgb(var(--clay))'}` }}
      >
        <svg width="22" height="22" viewBox="0 0 64 64" aria-hidden>
          <rect x="23" y="12" width="5" height="13" rx="2.5" fill="rgb(34,197,124)" />
          <rect x="36" y="12" width="5" height="13" rx="2.5" fill="rgb(34,197,124)" />
          <path d="M18 25h28v9a14 14 0 0 1-14 14 14 14 0 0 1-14-14z" fill="#ffffff" />
          <path d="M32 49v6" stroke="rgb(34,197,124)" strokeWidth="5" strokeLinecap="round" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-display text-[19px] font-extrabold tracking-[-0.02em] ${light ? 'text-white' : 'text-ink'}`}>
          The Clothing Plug
        </span>
        <span className={`mt-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${light ? 'text-white/50' : 'text-stone'}`}>
          London, Ontario
        </span>
      </span>
    </Link>
  );
}
